import { cn } from "@/utils/helpers";
import { getControlStatGroups, getLang } from "@/utils/selectors";
import Columns, { Column } from "@/components/common/Columns";
import ProfileTempExp from "./ProfileTempExp";
import ProfileTempOut from "./ProfileTempOut";
import styles from "../Profile.module.css";

export default function ProfileTemp() {

	return (
		<div
			className={cn(
				styles.ProfileStats,
				styles.ProfileTempStats
			)}
		>
			<Columns
				className={cn(
					styles.ProfileGroups,
					styles.ProfileTempGroups
				)}
			>
				{getControlStatGroups().map((group, index) =>
					<Column
						key={index}
						size={group === "exp" ? 3 : 9}
						title={getLang("stat", group)}
						titleTag="h3"
						className={cn(
							styles.ProfileGroup,
							styles.ProfileTempGroup,
							styles[`ProfileTempGroup_${group}`]
						)}
					>
						{group === "exp" ?
							<ProfileTempExp />
						: null}
						{group === "out" ?
							<ProfileTempOut />
						: null}
					</Column>
				)}
			</Columns>
		</div>
	);
}